
import './App.css';
import { Route, Routes } from 'react-router-dom';
import TopBar from './Components/LayoutWapper/Global/TopBar';

import SideBar from './Components/LayoutWapper/Global/SideBar';
import Candidate from '././Pages/Candidate'
import Home from "././Pages/Home"
import Profile from "././Pages/Profile"
import Previous from "./Components/Info/Previous"
import Upcoming from "./Components/Info/Upcoming"
import Edit from "././Pages/Edit"
import Interview from "././Pages/Interview"
import Jobs from "././Pages/Jobs"
import Resume from "././Pages/Resume"
import ResumeInfo from "././Pages/Resume/ResumeInfo";
import Skill from "././Pages/Skill"
import SubHome from "././Pages/Home/SubHome";
import Profile2 from "././Pages/Profile2"



function App() {
  return (
    <div className="App">
      <Routes>
    
       <Route path='/TopBar' element={<TopBar />} />
       <Route path='/SideBar' element={<SideBar />} />
       <Route path='/candidate' element={<Candidate />} /> 
     <Route path='/' element={<Home/>} /> 
    <Route path='/profile' element={<Profile/>} /> 
    <Route path='/profile2' element={<Profile2/>} /> 
    <Route path='/edit' element={<Edit />} /> 
    <Route path='/interview' element={<Interview />} />
    <Route path='/jobs' element={<Jobs />} />  
     <Route path='/resume' element={<Resume/>} />  
     <Route path='/skill' element={<Skill/>} />
     <Route path="/home"  element={<SubHome/>}></Route>
     <Route path="/Resume/ResumeInfo"  element={<ResumeInfo/>}></Route> 
     <Route path="/interview/Preview"  element={<Previous/>}></Route> 
     <Route path="/interview/Upcoming"  element={<Upcoming/>}></Route>   
      </Routes>  
    </div>
  );
}

export default App;
 